/// <reference path="../../typings/browser.d.ts" />
/// <reference path="../../customtypings/window.d.ts" />

/**
 * Network service
 */

namespace Application.Services {
    'use strict';

    import Network = Models.Network;
    import INetwork = Models.INetwork;
    import IHalList = Models.IHalList;
    import HalConverter = Models.HalConverter;
    import IHalElement = Models.IHalElement;


    /**
     * NetworkService
     */
    export class NetworkService {
        public static $name: string = "networkService";
        public static $inject: string[] = ['backendService', 'vnoService'];

        private backendService: BackendService;
        private backendBaseUrl: string = window.backendUrl;
        // private servicePath: string = 'networknodes/';
        private servicePath: string = '';
        private backendUrl: string = this.backendBaseUrl + this.servicePath + 'networks';

        constructor(backendService: BackendService,
                    private vnoService: Services.VnoService) {
            this.backendService = backendService;
        }
        
        public getByHref(href: string, callback: (result: Network) => void): void {
            this.getNetworkPromise(href).then(
                (data: Network) => {
                    callback(data);
                }
            );
        }

        public getAllNetworks(callback: (networks: INetwork[]) => void): void {
            this.getAllNetworksPromise()
                .then((data: INetwork[]) => {
                    callback(data);
                });
        }

        public getAllNetworksPromise(): ng.IPromise<INetwork[]> {
            return this.backendService
                .get(this.backendUrl + "/filtered?size=5000")
                .then((result: ng.IHttpPromiseCallbackArg<IHalList<INetwork>>) => {
                    let data: IHalList<INetwork> = result.data;
                    return HalConverter.convertList(data, Network.Empty);
                });
        }

        public addPositionToNetwork(href: string, x: number, y: number): ng.IPromise<Network> {
            return this.getNetworkPromise(href).then(
                 (network: Network) => {
                     network.x = x;
                     network.y = y;
                     return this.updateNetwork(network);
                 }
            );
        }

        public saveNetwork(network: Models.INetwork): ng.IPromise<Models.INetwork> {
            if (!network.href || network.href === undefined || network.href === '') {
                return this.createNetwork(network);
            } else {
                return this.updateNetwork(network);
            }
        }

        public createNetwork(network: Models.INetwork): ng.IPromise<Models.INetwork> {
            return this.backendService
                .post(this.backendUrl, network)
                .then((result: ng.IHttpPromiseCallbackArg<Models.IHalElement<INetwork>>) => {
                     return HalConverter.convertElement(result.data, Network.Empty);
                 });
        }

        public updateNetwork(network: Models.INetwork): ng.IPromise<Models.INetwork> {
            return this.backendService
                .put(network.href, {
                    name: network.name,
                    ipAddress: network.ipAddress,
                    subnetMask: network.subnetMask,
                    x: network.x,
                    y: network.y,
                })
                .then((result: ng.IHttpPromiseCallbackArg<Models.IHalElement<INetwork>>) => {
                    return HalConverter.convertElement(result.data, Network.Empty);
                });
        }
        
        public deleteNetwork(network: Models.INetwork): ng.IPromise<boolean> {
            return this.backendService.delete(network.href);
        }

        public getNetworkPromise(href: string): ng.IPromise<Network> {
            return this.backendService
                .get(href)
                .then((data: ng.IHttpPromiseCallbackArg<IHalElement<Network>>) => {
                    let halElement: IHalElement<Network> = data.data;
                    return HalConverter.convertElement(halElement, Network.Empty);
                });
        }

        public getNetworkById(id: number): ng.IPromise<Network> {
            return this.getNetworkPromise(this.backendUrl + '/' + id);
        }

        public getOrganizations(href: string): ng.IPromise<Models.Vno[]> {
            return this.getOrganizationIds(href)
                .then((res: number[]) => {
                    return this.vnoService.findAll()
                        .then((result: Models.Vno[]) => {
                            return result.filter( (vno: Models.Vno) => {
                                return res.indexOf( vno.id ) > -1;
                            });
                        });
                });
        }

        public getOrganizationIds(href: string): ng.IPromise<number[]> {
            return this.backendService.get(href + "/organization")
                .then((res: ng.IHttpPromiseCallbackArg<number[]>) => {
                    return res.data;
                });
        }

        public addOrganization(href: string, organizationId: number): ng.IPromise<boolean> {
            return this.backendService.post(href + "/organization/" + organizationId, {})
                .then((result: ng.IHttpPromiseCallbackArg<boolean>) => {
                    return result.data;
                });
        }

        public removeOrganization(href: string, organizationId: number): ng.IPromise<boolean> {
            return this.backendService.delete(href + "/organization/" + organizationId)
                .then((result: ng.IHttpPromiseCallbackArg<boolean>) => {
                    return result.data;
                });
        }

        public changeOrganizations(href: string, organizationIds: number[]): ng.IPromise<boolean> {
            return this.backendService
                .put(href + "/organizations", organizationIds)
                .then((result: ng.IHttpPromiseCallbackArg<boolean>) => {
                    return result.data;
                });
        }

        /**
         * This method checks if there is a network with the name provided
         *
         * @param name name to be checked
         * @return boolean true if the name is already in the database
         */
        public checkUsedNamePromise(name: string): ng.IPromise<boolean> {
            return this.backendService
                .get(this.backendUrl + "/usedName?name=" + name, false, undefined, false, false)
                .then((result: ng.IHttpPromiseCallbackArg<Boolean>) => {
                    return result.data;
                });
        }

    }
}